import { ToastContainer, toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";

export const API_BASE_URL = "https://abmtravel.sag.ci/api/amadeus";

// "https://hums4a4lwgk6go7q6slve7ce2e.apigateway.us-ashburn-1.oci.customer-oci.com/amadeus/api/amadeus";
export const API_BASE_URL2 = "https://abmtravel.sag.ci/api";
export const API_BASE_URL3 = "https://abmtravel.sag.ci/api/amadeus2";
// "https://hums4a4lwgk6go7q6slve7ce2e.apigateway.us-ashburn-1.oci.customer-oci.com/amadeus/api"; // Utilisez votre URL de base

export const getAirlineName = (code) => {
  const airlines = {
    // Europe
    HF:"Air Cote D'Ivoire",
    KP: "ASKY Airlines",
    AF: "Air France",
    LH: "Lufthansa",
    BA: "British Airways",
    KL: "KLM",
    SN: "Brussels Airlines",
    LX: "Swiss International Air Lines",
    IB: "Iberia",
    AZ: "Alitalia",
    TP: "TAP Air Portugal",
    AY: "Finnair",
    SK: "SAS Scandinavian Airlines",
    LO: "LOT Polish Airlines",
    OS: "Austrian Airlines",
    SU: "Aeroflot",
    TK: "Turkish Airlines",
    A3: "Aegean Airlines",
    DY: "Norwegian Air Shuttle",
    FR: "Ryanair",
    U2: "easyJet",
    VY: "Vueling",
    EW: "Eurowings",
    BT: "Air Baltic",
    JU: "Air Serbia",
    OU: "Croatia Airlines",
    KM: "Air Malta",
    FI: "Icelandair",

    // Moyen-Orient
    EK: "Emirates",
    EY: "Etihad Airways",
    QR: "Qatar Airways",
    SV: "Saudia",
    RJ: "Royal Jordanian",
    WY: "Oman Air",
    GF: "Gulf Air",
    KU: "Kuwait Airways",
    ME: "Middle East Airlines",

    // Afrique
    ET: "Ethiopian Airlines",
    MS: "EgyptAir",
    AT: "Royal Air Maroc",
    TU: "Tunisair",
    KQ: "Kenya Airways",
    SA: "South African Airways",
    MK: "Air Mauritius",
    UL: "SriLankan Airlines",
    WB: "RwandAir",
    P4: "Air Peace",
    "9U": "Air Moldova",

    // Amérique du Nord
    AA: "American Airlines",
    DL: "Delta Air Lines",
    UA: "United Airlines",
    AC: "Air Canada",
    WN: "Southwest Airlines",
    B6: "JetBlue Airways",
    AS: "Alaska Airlines",
    WS: "WestJet",
    F9: "Frontier Airlines",

    // Amérique du Sud
    LA: "LATAM Airlines",
    AV: "Avianca",
    CM: "Copa Airlines",
    AR: "Aerolíneas Argentinas",
    G3: "Gol Transportes Aéreos",
    AD: "Azul Brazilian Airlines",
    JJ: "LATAM Brasil",

    // Asie
    SQ: "Singapore Airlines",
    CX: "Cathay Pacific",
    NH: "ANA All Nippon Airways",
    JL: "Japan Airlines",
    KE: "Korean Air",
    OZ: "Asiana Airlines",
    CI: "China Airlines",
    BR: "EVA Air",
    TG: "Thai Airways",
    MH: "Malaysia Airlines",
    GA: "Garuda Indonesia",
    PR: "Philippine Airlines",
    VN: "Vietnam Airlines",
    CZ: "China Southern Airlines",
    MU: "China Eastern Airlines",
    CA: "Air China",
    HU: "Hainan Airlines",
    FM: "Shanghai Airlines",
    "3U": "Sichuan Airlines",
    "9C": "Spring Airlines",

    // Océanie
    QF: "Qantas",
    VA: "Virgin Australia",
    NZ: "Air New Zealand",
    FJ: "Fiji Airways",

    // Compagnies low-cost
    NK: "Spirit Airlines",
    SY: "Sun Country Airlines",
    G4: "Allegiant Air",
    Y4: "Volaris",
    Y9: "Air Arabia",
    FD: "Thai AirAsia",
    AK: "AirAsia",
    D7: "AirAsia X",
    TR: "Scoot",
    Z2: "Philippines AirAsia",

    // Compagnies cargo
    "5Y": "Atlas Air",
    K4: "Kalitta Air",
    W8: "Cargojet Airways",

    // Régionales
    YX: "Republic Airways",
    OO: "SkyWest Airlines",
    "9E": "Endeavor Air",
    MQ: "Envoy Air",
    OH: "PSA Airlines",

    // Autres
    "2J": "Air Burkina",
    AI: "Air India",
    PK: "Pakistan International Airlines",
    BG: "Biman Bangladesh Airlines",
    UL: "SriLankan Airlines",
    UL: "SriLankan Airlines",
    BI: "Royal Brunei Airlines",
    OM: "MIAT Mongolian Airlines",
    RGN: "Regional Express",
    J2: "Azerbaijan Airlines",
    KC: "Air Astana",
    HY: "Uzbekistan Airways",
    FV: "Rossiya Airlines",
    S7: "S7 Airlines",
    U6: "Ural Airlines",
    "5N": "Nordavia",
    D2: "Severstal Air Company",
    N4: "Nordwind Airlines",
    ZF: "Azur Air",
    Y7: "NordStar Airlines",
    DP: "Pobeda",
    "6W": "Saratov Airlines",
    B2: "Belavia",
    "7J": "Tajik Air",
    NQ: "Air Japan",
    JW: "Vanilla Air",
    MM: "Peach Aviation",
    GK: "Jetstar Japan",
    BC: "Skymark Airlines",
    LJ: "Jin Air",
    ZE: "Eastar Jet",
    TW: "Tway Air",
    BX: "Air Busan",
    RS: "Air Seoul",
    VZ: "Thai Vietjet Air",
    SL: "Thai Lion Air",
    DD: "Nok Air",
    XJ: "Thai AirAsia X",
    Z8: "Amaszonas",
    "8L": "Lucky Air",
    GJ: "Loong Air",
    DR: "Ruili Airlines",
    A6: "Air Travel",
    GT: "Air Guilin",
    QW: "Qingdao Airlines",
    CN: "West Air",
    PN: "China West Air",
    RY: "Jiangxi Air",
    VD: "Henan Airlines",
    G5: "China Express Air",
    "9H": "Air Changan",
    NS: "Hebei Airlines",
    KN: "China United",
    JD: "Capital Airlines",
    DZ: "Donghai Airlines",
    Y8: "Yangtze River Express",
    OQ: "Chongqing Airlines",
    GX: "GX Airlines",
    AQ: "9 Air",
    EU: "Chengdu Airlines",
    UQ: "Urumqi Air",
    QW: "Qingdao Airlines",
    RY: "Jiangxi Air",
    VD: "Henan Airlines",
  };

  return airlines[code] || code;
};

export const formatAmount = (amount, defaultValue = 0) => {
  const num = parseFloat(amount);
  return isNaN(num) ? defaultValue.toFixed(2) : num.toFixed(2);
};

export const dateIntl = (iso) => {
  const date = new Date(iso);

  const dateFormatee = new Intl.DateTimeFormat("fr-FR", {
    day: "numeric",
    weekday: "long",
    year: "numeric",
    month: "long",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  }).format(date);

  return dateFormatee;
};

export const getSafeAmount = (amount, defaultValue = 0) => {
  const num = parseFloat(amount);
  return isNaN(num) ? defaultValue : num;
};

export const amadeusService = {
  searchFlights: async (searchParams) => {

    console.log('AMADEUS searchParams',searchParams)
    try {
      const params = {
        originLocationCode: searchParams.originLocationCode,
        destinationLocationCode: searchParams.destinationLocationCode,
        departureDate: searchParams.departureDate,
        adults: searchParams.adults,
        max: searchParams.max || 10,
        children: searchParams.children || 0,
        infants: searchParams.infants || 0,
        travelClass: searchParams.travelClass || "ECONOMY",
      };

      // Ajouter la date de retour si c'est un aller-retour
      if (searchParams.tripType === "round-trip" && searchParams.returnDate) {
        params.returnDate = searchParams.returnDate;
      }

      const queryParams = new URLSearchParams(params).toString();
      const response = await fetch(`${API_BASE_URL}/flights?${queryParams}`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });

      if (!response.ok) {
        console.error("Erreur HTTP:", response.status);
        throw new Error(`Erreur HTTP: ${response.status}`);
      }

      const data = await response.json();
      console.log("Données reçues:", data); // Pour déboguer
      return data;
    } catch (error) {
      console.error("Erreur recherche vols:", error);
      throw error;
    }
  },

  searchHotels: async (searchParams) => {
    try {
      const queryParams = new URLSearchParams(searchParams).toString();
      const response = await fetch(`${API_BASE_URL3}/hotels?${queryParams}`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });
      if (!response.ok) throw new Error(`Erreur HTTP: ${response.status}`);
      return await response.json();
    } catch (error) {
      console.error("Erreur recherche hôtels:", error);
      throw error;
    }
  },

  getHotelOffers1: async (hotelId, params) => {
    try {
      // Créer un nouvel objet params sans la propriété hotelIds si elle existe
      const { hotelIds, ...otherParams } = params;

      const queryParams = new URLSearchParams({
        ...otherParams,
        hotelIds: hotelId, // Utiliser le hotelId passé en premier argument
        roomQuantity: params.rooms || params.roomQuantity, // S'assurer d'utiliser roomQuantity
      }).toString();

      console.log("DONNEES RECHRECHE HOTEL", queryParams);
      const response = await fetch(
        `${API_BASE_URL3}/hotel-offers?${queryParams}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
        }
      );
      console.log("apres ICI", response.json());
      if (!response.ok) throw new Error(`Erreur HTTP: ${response.status}`);
      return await response.json();
    } catch (error) {
      console.error("Erreur offres hôtel:", error);
      throw error;
    }
  },
  getHotelOffers: async (hotelId, params) => {
    try {
      // Préparer les données pour le body (format JSON)
      const requestBody = {
        hotelIds: hotelId, // Utiliser le hotelId passé en premier argument
        checkInDate: params.checkInDate,
        checkOutDate: params.checkOutDate,
        adults: params.adults,
        roomQuantity: params.rooms || params.roomQuantity || "1",
        // Ajouter d'autres paramètres si nécessaires
        children: params.children || "0",
        infants: params.infants || "0",
        currency: params.currency || "EUR",
      };

      // Nettoyer l'objet (supprimer les propriétés undefined)
      Object.keys(requestBody).forEach((key) => {
        if (requestBody[key] === undefined) {
          delete requestBody[key];
        }
      });

      console.log("DONNEES RECHERCHE HOTEL", requestBody);

      const response = await fetch(`${API_BASE_URL3}/hotel-offers`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody), // Envoyer dans le body
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Erreur HTTP: ${response.status} - ${errorText}`);
      }

      const data = await response.json();
      console.log("Réponse offres hôtel:", data);
      return data;
    } catch (error) {
      console.error("Erreur offres hôtel:", error);
      throw error;
    }
  },
  /// A UTILISER http://149.202.45.76:1820/amadeus2/flights/orders
  ///http://149.202.45.76:1820/amadeus2/flights/pricing
  //http://149.202.45.76:1820/amadeus2/flights/orders
  /// http://149.202.45.76:1820/amadeus2/flights/orders/1/ticket (Pas de route)
  ///http://149.202.45.76:1820/amadeus2/flights/complete-booking
  getSeatmap: async (flightOfferId) => {
    try {
      // D'abord, faire le pricing pour obtenir les détails
      const pricingResponse = await fetch(
        `${API_BASE_URL}/flight-offers/pricing`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            data: {
              type: "flight-offers-pricing",
              flightOffers: [flightOfferId],
            },
          }),
        }
      );

      if (!pricingResponse.ok) throw new Error("Erreur pricing");
      const pricingData = await pricingResponse.json();

      // Ensuite récupérer la seatmap
      const seatmapResponse = await fetch(`${API_BASE_URL}/seatmaps`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          data: pricingData.data,
        }),
      });

      if (!seatmapResponse.ok) throw new Error("Erreur récupération seatmap");
      return await seatmapResponse.json();
    } catch (error) {
      console.error("Erreur seatmap:", error);
      throw error;
    }
  },
  getFlightPricingWithSeats: async (flightOffer) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/flight-offers/pricing?include=seats`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            data: {
              type: "flight-offers-pricing",
              flightOffers: [flightOffer],
            },
          }),
        }
      );

      if (!response.ok) throw new Error("Erreur pricing avec sièges");
      return await response.json();
    } catch (error) {
      console.error("Erreur:", error);
      throw error;
    }
  },
};

export const flightRequestsService = {
  getAll: async () => {
    const response = await fetch(`${API_BASE_URL2}/flight-requests`);
    if (!response.ok) throw new Error("Erreur récupération demandes");
    return await response.json();
  },

  create: async (data) => {
    // Ajouter un timestamp pour éviter les doublons
    const requestData = {
      ...data,
      _submittedAt: new Date().toISOString(),
    };

    const response = await fetch(`${API_BASE_URL2}/flight-requests`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestData),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || "Erreur création demande");
    }

    return await response.json();
  },

  approve: async (id) => {
    const response = await fetch(
      `${API_BASE_URL2}/flight-requests/${id}/approve`,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
      }
    );
    if (!response.ok) throw new Error("Erreur approbation");
    return await response.json();
  },

  reject: async (id) => {
    const response = await fetch(
      `${API_BASE_URL2}/flight-requests/${id}/reject`,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
      }
    );
    if (!response.ok) throw new Error("Erreur rejet");
    return await response.json();
  },

  emitTicket: async (id) => {
    try {
      console.log(`🎫 Début de l'émission du ticket pour la demande: ${id}`);

      // 1. Récupérer les détails de la demande pour obtenir les données nécessaires
      const requestResponse = await fetch(
        `${API_BASE_URL2}/flight-requests/${id}`
      );
      if (!requestResponse.ok) {
        toast.error(
          "Erreur lors de la récupération des détails de la demande"
        );
        return;
      }
      const request = await requestResponse.json();

      // 2. Vérifier qu'il y a des voyageurs et des données de vol
      if (!request.travelers || request.travelers.length === 0) {
        toast.error("Aucun voyageur trouvé pour cette demande");
        return;
      }

      if (!request.vol || request.vol.length === 0) {
        toast.error("Aucune offre de vol trouvée pour cette demande");
        return;
      }

      // 3. Préparer les données pour Amadeus complete-booking
      const searchParams = request.searchParams || request.vol[0]?.searchParams;
      const adultsCount = parseInt(searchParams?.adults) || 1;
      const childrenCount = parseInt(searchParams?.children) || 0;
      const infantsCount = parseInt(searchParams?.infants) || 0;

      // Fonction pour nettoyer le countryCallingCode
      const cleanCountryCallingCode = (code) => {
        if (!code) return "225";
        return code.replace(/[^\d]/g, "");
      };

      // Préparer les voyageurs au format Amadeus
      const amadeusTravelers = request.travelers.map((traveler, index) => {
        let passengerType = "ADULT";
        if (index >= adultsCount && index < adultsCount + childrenCount) {
          passengerType = "CHILD";
        } else if (index >= adultsCount + childrenCount) {
          passengerType = "INFANT";
        }

        return {
          id: (index + 1).toString(),
          dateOfBirth: traveler.date_naissance,
          name: {
            firstName: traveler.prenom,
            lastName: traveler.nom,
          },
          gender: traveler.genre || "MALE",
          contact: {
            emailAddress: traveler.email || "info@abmtravel.com",
            phones: [
              {
                deviceType: "MOBILE",
                countryCallingCode: cleanCountryCallingCode(traveler.code_pays),
                number: traveler.telephone || "0708837660",
              },
            ],
          },
          documents: [
            {
              documentType: "PASSPORT",
              birthPlace: traveler.lieu_naissance || "Abidjan",
              issuanceLocation: traveler.lieu_emission || "Abidjan",
              issuanceDate: traveler.date_emission_passeport || "2020-01-01",
              number: traveler.numero_passeport,
              expiryDate: traveler.date_expiration_passeport,
              issuanceCountry: traveler.pays_emission || "CI",
              validityCountry: traveler.pays_validite || "CI",
              nationality: traveler.nationalite || "CI",
              holder: true,
            },
          ],
        };
      });

      // CORRECTION : Préparer les flightOffers avec la structure Amadeus correcte
      const correctedFlightOffers = request.vol.map((offer) => {
        const flightData = offer.flightData;

        return {
          type: "flight-offer",
          id: flightData.id,
          source: flightData.source,
          instantTicketingRequired: flightData.instantTicketingRequired,
          nonHomogeneous: flightData.nonHomogeneous,
          oneWay: flightData.oneWay,
          lastTicketingDate: flightData.lastTicketingDate,
          numberOfBookableSeats: flightData.numberOfBookableSeats,
          itineraries: flightData.itineraries,
          price: flightData.price,
          pricingOptions: flightData.pricingOptions,
          validatingAirlineCodes: flightData.validatingAirlineCodes,
          travelerPricings: flightData.travelerPricings,
        };
      });

      // CORRECTION : Formater correctement le délai pour Amadeus
      const formatDelayForAmadeus = (delay) => {
        if (delay === "24H") return "1D";
        if (delay === "48H") return "2D";
        if (delay === "72H") return "3D";
        return delay;
      };

      // Structure pour Amadeus
      const amadeusBookingData = {
        type: "flight-order",
        flightOffers: correctedFlightOffers,
        travelers: amadeusTravelers,
        remarks: {
          general: [
            {
              subType: "GENERAL_MISCELLANEOUS",
              text: `Billet émis via système - Demande: ${request.numeroRequete}`,
            },
          ],
        },
        ticketingAgreement: {
          option: "DELAY_TO_CANCEL",
          delay: formatDelayForAmadeus("24H"),
        },
        contacts: [
          {
            addresseeName: {
              firstName: "Support",
              lastName: "Voyages",
            },
            companyName: "Agence de Voyage",
            purpose: "STANDARD",
            phones: [
              {
                deviceType: "LANDLINE",
                countryCallingCode: "33",
                number: "0123456789",
              },
            ],
            emailAddress: "support@voyage.com",
            address: {
              lines: ["123 Avenue des Voyages"],
              postalCode: "75001",
              cityName: "Paris",
              countryCode: "FR",
            },
          },
        ],
      };

      console.log(
        "DONNEES AMADEUS CORRIGEES:",
        JSON.stringify(amadeusBookingData, null, 2)
      );

      // 4. Lancer les opérations en parallèle
      const operations = [];

      // Opération 1: Appel à l'API interne pour émettre le ticket
      operations.push(
        (async () => {
          try {
            console.log("🎫 Émission du ticket interne...");
            const response = await fetch(
              `${API_BASE_URL2}/flight-requests/${id}/emit-ticket`,
              {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
              }
            );

            if (!response.ok) {
              const errorText = await response.text();
              toast.error(`Interne: ${response.status} - ${errorText}`);
              return;
            }

            const result = await response.json();
            console.log("✅ Ticket interne émis avec succès");
            return {
              success: true,
              type: "internal",
              data: result,
            };
          } catch (error) {
            console.error("❌ Erreur émission ticket interne:", error.message);
            return {
              success: false,
              type: "internal",
              error: error.message,
            };
          }
        })()
      );

      // CORRECTION : Vérifier et utiliser le bon endpoint Amadeus
      // Option 1: Essayer avec l'endpoint standard de booking Amadeus
      const amadeusEndpoints = [
        // `${API_BASE_URL}/booking`, // Endpoint standard Amadeus
        // `${API_BASE_URL3}/v1/booking/flight-orders`, // Avec version
        `${API_BASE_URL3}/flights/complete-booking`, // Endpoint original (au cas où)
      ];

      // Opération 2: Complete-booking Amadeus avec données corrigées
      operations.push(
        (async () => {
          try {
            console.log("🚀 Appel à Amadeus complete-booking...");

            let amadeusResponse;
            let lastError;

            // Essayer différents endpoints
            for (const endpoint of amadeusEndpoints) {
              try {
                console.log(`🔍 Essai avec l'endpoint: ${endpoint}`);
                amadeusResponse = await fetch(endpoint, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(amadeusBookingData),
                });

                if (amadeusResponse.ok) {
                  console.log(`✅ Endpoint trouvé: ${endpoint}`);
                  break;
                } else {
                  const errorText = await amadeusResponse.text();
                  lastError = new Error(
                    `Amadeus (${endpoint}): ${
                      errorText || `HTTP ${amadeusResponse.status}`
                    }`
                  );
                  console.log(
                    `❌ Échec avec ${endpoint}: ${amadeusResponse.status}`
                  );
                }
              } catch (endpointError) {
                lastError = endpointError;
                console.log(
                  `❌ Erreur avec ${endpoint}: ${endpointError.message}`
                );
              }
            }

            if (!amadeusResponse || !amadeusResponse.ok) {
              throw (
                lastError || new Error("Aucun endpoint Amadeus ne fonctionne")
              );
            }

            const amadeusResult = await amadeusResponse.json();
            console.log("✅ Complete-booking Amadeus réussi");

            // Extraire les informations importantes
            const amadeusData = amadeusResult.data;
            return {
              success: true,
              type: "amadeus",
              data: amadeusResult,
              orderId: amadeusData?.orderId,
              pnr: amadeusData?.pnr,
              associatedRecords: amadeusData?.associatedRecords,
            };
          } catch (amadeusError) {
            console.error(
              "❌ Erreur complete-booking Amadeus:",
              amadeusError.message
            );
            return {
              success: false,
              type: "amadeus",
              error: amadeusError.message,
            };
          }
        })()
      );

      // Opération 3: Synchronisation des voyages
      operations.push(
        (async () => {
          try {
            console.log("🔄 Synchronisation des voyages...");
            const syncResponse = await fetch(
              `${API_BASE_URL2}/travelers/sync`,
              {
                method: "POST",
                headers: { "Content-Type": "application/json" },
              }
            );

            if (!syncResponse.ok)
              throw new Error(`Sync: ${syncResponse.status}`);

            console.log("✅ Synchronisation des voyages réussie");
            return {
              success: true,
              type: "sync",
            };
          } catch (syncError) {
            console.error(
              "❌ Erreur synchronisation voyages:",
              syncError.message
            );
            return {
              success: false,
              type: "sync",
              error: syncError.message,
            };
          }
        })()
      );

      // 5. Exécuter toutes les opérations en parallèle
      const results = await Promise.allSettled(operations);

      // 6. Traiter les résultats
      const finalResults = {
        internal: null,
        amadeus: null,
        sync: null,
      };

      results.forEach((result) => {
        if (result.status === "fulfilled") {
          const value = result.value;
          switch (value.type) {
            case "internal":
              finalResults.internal = value;
              break;
            case "amadeus":
              finalResults.amadeus = value;
              break;
            case "sync":
              finalResults.sync = value;
              break;
          }
        }
      });

      // 7. Vérifier si l'émission interne a réussi (critique)
      if (!finalResults.internal || !finalResults.internal.success) {
        throw new Error(
          "Émission interne a échoué: " +
            (finalResults.internal?.error || "Unknown error")
        );
      }

      // 8. Construire le résultat final
      const finalResult = {
        ...finalResults.internal.data,
        operations: {
          internal: { success: true, data: finalResults.internal.data },
          amadeus: finalResults.amadeus || {
            success: false,
            error: "Non exécuté",
          },
          sync: finalResults.sync || { success: false, error: "Non exécuté" },
        },
      };

      // 9. Log du résumé
      console.log("📊 Résumé des opérations:");
      console.log("- Interne: ✅ Succès");
      console.log(
        `- Amadeus: ${finalResult.operations.amadeus.success ? "✅" : "❌"} ${
          finalResult.operations.amadeus.success
            ? "Succès"
            : finalResult.operations.amadeus.error
        }`
      );
      console.log(
        `- Synchronisation: ${
          finalResult.operations.sync.success ? "✅" : "❌"
        } ${
          finalResult.operations.sync.success
            ? "Succès"
            : finalResult.operations.sync.error
        }`
      );

      // 10. Si Amadeus a réussi, mettre à jour la demande avec les infos Amadeus
      if (finalResult.operations.amadeus.success) {
        try {
          console.log("💾 Mise à jour des informations Amadeus...");
          const updateData = {
            amadeusOrderId: finalResult.operations.amadeus.orderId,
            amadeusPnr: finalResult.operations.amadeus.pnr,
            amadeusData: finalResult.operations.amadeus.data,
          };

          await fetch(`${API_BASE_URL2}/flight-requests/${id}/amadeus-info`, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(updateData),
          });
          console.log("✅ Informations Amadeus mises à jour");
        } catch (updateError) {
          console.error("❌ Erreur mise à jour infos Amadeus:", updateError);
        }
      }

      return finalResult;
    } catch (error) {
      console.error("❌ Erreur globale emitTicket:", error);
      throw error;
    }
  },

  delete: async (id) => {
    const response = await fetch(`${API_BASE_URL2}/flight-requests/${id}`, {
      method: "DELETE",
    });
    if (!response.ok) throw new Error("Erreur suppression");
    return await response.json();
  },
};


export const confirmToast = (message, onConfirm, onCancel) => {
  toast(
    ({ closeToast }) => (
      <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
        <span style={{ textAlign: "center" }}>{message}</span>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "12px",
            marginTop: "8px",
          }}
        >
          <button
            style={{
              padding: "6px 14px",
              background: "#2563eb",
              color: "white",
              borderRadius: "4px",
              border: "none",
              cursor: "pointer",
            }}
            onClick={() => {
              onConfirm();
              closeToast();
            }}
          >
            Confirmer
          </button>

          <button
            style={{
              padding: "6px 14px",
              background: "#f50424ff",
              color: "white",
              borderRadius: "4px",
              border: "none",
              cursor: "pointer",
            }}
            onClick={() => {
              onCancel && onCancel();
              closeToast();
            }}
          >
            Annuler
          </button>
        </div>
      </div>
    ),
    {
      autoClose: false,
      closeOnClick: false,
      position: "top-center",
    }
  );
};

export const airports = [
  {
    label: "Afrique",
    options: [
      { value: "ABJ", label: "Abidjan, Côte d'Ivoire (ABJ)" },
      { value: "ABV", label: "Abuja, Nigeria (ABV)" },
      { value: "ACC", label: "Accra, Ghana (ACC)" },
      { value: "ADD", label: "Addis-Abeba, Éthiopie (ADD)" },
      { value: "ALG", label: "Alger, Algérie (ALG)" },
      { value: "ASM", label: "Asmara, Érythrée (ASM)" },
      { value: "ASW", label: "Assouan, Égypte (ASW)" },
      { value: "BKO", label: "Bamako, Mali (BKO)" },
      { value: "BJM", label: "Bujumbura, Burundi (BJM)" },
      { value: "BLZ", label: "Blantyre, Malawi (BLZ)" },
      { value: "CAI", label: "Le Caire, Égypte (CAI)" },
      { value: "CKY", label: "Conakry, Guinée (CKY)" },
      { value: "CMN", label: "Casablanca, Maroc (CMN)" },
      { value: "COO", label: "Cotonou, Bénin (COO)" },
      { value: "CPT", label: "Le Cap, Afrique du Sud (CPT)" },
      { value: "DAR", label: "Dar es Salaam, Tanzanie (DAR)" },
      { value: "DKR", label: "Dakar, Sénégal (DKR)" },
      { value: "DLA", label: "Douala, Cameroun (DLA)" },
      { value: "DSS", label: "Dakar Blaise Diagne, Sénégal (DSS)" },
      { value: "DUR", label: "Durban, Afrique du Sud (DUR)" },
      { value: "EBB", label: "Entebbe, Ouganda (EBB)" },
      { value: "FIH", label: "Kinshasa, RDC (FIH)" },
      { value: "FNA", label: "Freetown, Sierra Leone (FNA)" },
      { value: "GBE", label: "Gaborone, Botswana (GBE)" },
      { value: "HRE", label: "Harare, Zimbabwe (HRE)" },
      { value: "JNB", label: "Johannesburg, Afrique du Sud (JNB)" },
      { value: "KAN", label: "Kano, Nigeria (KAN)" },
      { value: "KGL", label: "Kigali, Rwanda (KGL)" },
      { value: "LAD", label: "Luanda, Angola (LAD)" },
      { value: "LBV", label: "Libreville, Gabon (LBV)" },
      { value: "LFW", label: "Lomé, Togo (LFW)" },
      { value: "LOS", label: "Lagos, Nigeria (LOS)" },
      { value: "LUN", label: "Lusaka, Zambie (LUN)" },
      { value: "LXR", label: "Louxor, Égypte (LXR)" },
      { value: "MBA", label: "Mombasa, Kenya (MBA)" },
      { value: "MRU", label: "Port-Louis, Maurice (MRU)" },
      { value: "MPM", label: "Maputo, Mozambique (MPM)" },
      { value: "NBO", label: "Nairobi, Kenya (NBO)" },
      { value: "NDJ", label: "N'Djamena, Tchad (NDJ)" },
      { value: "NIM", label: "Niamey, Niger (NIM)" },
      { value: "NKC", label: "Nouakchott, Mauritanie (NKC)" },
      { value: "OUA", label: "Ouagadougou, Burkina Faso (OUA)" },
      { value: "RAI", label: "Praia, Cap-Vert (RAI)" },
      { value: "RUN", label: "Saint-Denis, La Réunion (RUN)" },
      { value: "SEZ", label: "Mahé, Seychelles (SEZ)" },
      { value: "SSH", label: "Charm el-Cheikh, Égypte (SSH)" },
      { value: "TIP", label: "Tripoli, Libye (TIP)" },
      { value: "TUN", label: "Tunis, Tunisie (TUN)" },
      { value: "TNR", label: "Antananarivo, Madagascar (TNR)" },
      { value: "VFA", label: "Victoria Falls, Zimbabwe (VFA)" },
      { value: "WDH", label: "Windhoek, Namibie (WDH)" },
      { value: "YAO", label: "Yaoundé, Cameroun (YAO)" },
      { value: "ZNZ", label: "Zanzibar, Tanzanie (ZNZ)" },
    ],
  },
  {
    label: "Europe",
    options: [
      { value: "AMS", label: "Amsterdam, Pays-Bas (AMS)" },
      { value: "ATH", label: "Athènes, Grèce (ATH)" },
      { value: "BCN", label: "Barcelone, Espagne (BCN)" },
      { value: "BER", label: "Berlin, Allemagne (BER)" },
      { value: "BRU", label: "Bruxelles, Belgique (BRU)" },
      { value: "BUD", label: "Budapest, Hongrie (BUD)" },
      { value: "CDG", label: "Paris Charles de Gaulle, France (CDG)" },
      { value: "CPH", label: "Copenhague, Danemark (CPH)" },
      { value: "DUB", label: "Dublin, Irlande (DUB)" },
      { value: "FCO", label: "Rome Fiumicino, Italie (FCO)" },
      { value: "FRA", label: "Francfort, Allemagne (FRA)" },
      { value: "GVA", label: "Genève, Suisse (GVA)" },
      { value: "IST", label: "Istanbul, Turquie (IST)" },
      { value: "LHR", label: "Londres Heathrow, Royaume-Uni (LHR)" },
      { value: "LIS", label: "Lisbonne, Portugal (LIS)" },
      { value: "MAD", label: "Madrid, Espagne (MAD)" },
      { value: "MAN", label: "Manchester, Royaume-Uni (MAN)" },
      { value: "MUC", label: "Munich, Allemagne (MUC)" },
      { value: "OSL", label: "Oslo, Norvège (OSL)" },
      { value: "ORY", label: "Paris Orly, France (ORY)" },
      { value: "PRG", label: "Prague, République tchèque (PRG)" },
      { value: "SVO", label: "Moscou Sheremetyevo, Russie (SVO)" },
      { value: "VIE", label: "Vienne, Autriche (VIE)" },
      { value: "WAW", label: "Varsovie, Pologne (WAW)" },
      { value: "ZRH", label: "Zurich, Suisse (ZRH)" },
    ],
  },
  {
    label: "Asie",
    options: [
      { value: "AMD", label: "Ahmedabad, Inde (AMD)" },
      { value: "BKK", label: "Bangkok, Thaïlande (BKK)" },
      { value: "BLR", label: "Bangalore, Inde (BLR)" },
      { value: "BOM", label: "Mumbai, Inde (BOM)" },
      { value: "CAN", label: "Guangzhou, Chine (CAN)" },
      { value: "CCU", label: "Kolkata, Inde (CCU)" },
      { value: "CGK", label: "Jakarta, Indonésie (CGK)" },
      { value: "CMB", label: "Colombo, Sri Lanka (CMB)" },
      { value: "DEL", label: "Delhi, Inde (DEL)" },
      { value: "DXB", label: "Dubaï, Émirats arabes unis (DXB)" },
      { value: "HAN", label: "Hanoï, Vietnam (HAN)" },
      { value: "HKG", label: "Hong Kong (HKG)" },
      { value: "HYD", label: "Hyderabad, Inde (HYD)" },
      { value: "ICN", label: "Séoul Incheon, Corée du Sud (ICN)" },
      { value: "KHI", label: "Karachi, Pakistan (KHI)" },
      { value: "KUL", label: "Kuala Lumpur, Malaisie (KUL)" },
      { value: "KWI", label: "Koweït City, Koweït (KWI)" },
      { value: "MNL", label: "Manille, Philippines (MNL)" },
      { value: "NRT", label: "Tokyo Narita, Japon (NRT)" },
      { value: "PEK", label: "Pékin, Chine (PEK)" },
      { value: "PVG", label: "Shanghai Pudong, Chine (PVG)" },
      { value: "RUH", label: "Riyad, Arabie saoudite (RUH)" },
      { value: "SGN", label: "Ho Chi Minh-Ville, Vietnam (SGN)" },
      { value: "SIN", label: "Singapour (SIN)" },
      { value: "TPE", label: "Taipei, Taïwan (TPE)" },
      { value: "TLV", label: "Tel Aviv, Israël (TLV)" },
    ],
  },
  {
    label: "Amérique du Nord",
    options: [
      { value: "ATL", label: "Atlanta, États-Unis (ATL)" },
      { value: "BOS", label: "Boston, États-Unis (BOS)" },
      { value: "CLT", label: "Charlotte, États-Unis (CLT)" },
      { value: "DEN", label: "Denver, États-Unis (DEN)" },
      { value: "DFW", label: "Dallas/Fort Worth, États-Unis (DFW)" },
      { value: "EWR", label: "Newark, États-Unis (EWR)" },
      { value: "IAD", label: "Washington Dulles, États-Unis (IAD)" },
      { value: "IAH", label: "Houston, États-Unis (IAH)" },
      { value: "JFK", label: "New York JFK, États-Unis (JFK)" },
      { value: "LAS", label: "Las Vegas, États-Unis (LAS)" },
      { value: "LAX", label: "Los Angeles, États-Unis (LAX)" },
      { value: "MCO", label: "Orlando, États-Unis (MCO)" },
      { value: "MEX", label: "Mexico, Mexique (MEX)" },
      { value: "MIA", label: "Miami, États-Unis (MIA)" },
      { value: "ORD", label: "Chicago O'Hare, États-Unis (ORD)" },
      { value: "PHX", label: "Phoenix, États-Unis (PHX)" },
      { value: "SAN", label: "San Diego, États-Unis (SAN)" },
      { value: "SEA", label: "Seattle, États-Unis (SEA)" },
      { value: "SFO", label: "San Francisco, États-Unis (SFO)" },
      { value: "YUL", label: "Montréal, Canada (YUL)" },
      { value: "YVR", label: "Vancouver, Canada (YVR)" },
      { value: "YYZ", label: "Toronto, Canada (YYZ)" },
    ],
  },
  {
    label: "Amérique centrale et Caraïbes",
    options: [
      { value: "CUN", label: "Cancún, Mexique (CUN)" },
      { value: "GDL", label: "Guadalajara, Mexique (GDL)" },
      { value: "HAV", label: "La Havane, Cuba (HAV)" },
      { value: "MBJ", label: "Montego Bay, Jamaïque (MBJ)" },
      { value: "NAS", label: "Nassau, Bahamas (NAS)" },
      { value: "POP", label: "Puerto Plata, République dominicaine (POP)" },
      { value: "PTY", label: "Panama City, Panama (PTY)" },
      { value: "PUJ", label: "Punta Cana, République dominicaine (PUJ)" },
      { value: "SJO", label: "San José, Costa Rica (SJO)" },
      { value: "SJU", label: "San Juan, Porto Rico (SJU)" },
    ],
  },
  {
    label: "Amérique du Sud",
    options: [
      { value: "BOG", label: "Bogotá, Colombie (BOG)" },
      { value: "BSB", label: "Brasília, Brésil (BSB)" },
      { value: "BUE", label: "Buenos Aires, Argentine (BUE)" },
      { value: "CCS", label: "Caracas, Venezuela (CCS)" },
      { value: "EZE", label: "Buenos Aires Ezeiza, Argentine (EZE)" },
      { value: "FOR", label: "Fortaleza, Brésil (FOR)" },
      { value: "GIG", label: "Rio de Janeiro, Brésil (GIG)" },
      { value: "GRU", label: "São Paulo, Brésil (GRU)" },
      { value: "GYE", label: "Guayaquil, Équateur (GYE)" },
      { value: "LIM", label: "Lima, Pérou (LIM)" },
      { value: "SCL", label: "Santiago, Chili (SCL)" },
      { value: "UIO", label: "Quito, Équateur (UIO)" },
    ],
  },
  {
    label: "Océanie",
    options: [
      { value: "AKL", label: "Auckland, Nouvelle-Zélande (AKL)" },
      { value: "BNE", label: "Brisbane, Australie (BNE)" },
      { value: "CHC", label: "Christchurch, Nouvelle-Zélande (CHC)" },
      { value: "MEL", label: "Melbourne, Australie (MEL)" },
      { value: "NAN", label: "Nadi, Fidji (NAN)" },
      { value: "PER", label: "Perth, Australie (PER)" },
      { value: "PPT", label: "Papeete, Polynésie française (PPT)" },
      { value: "SYD", label: "Sydney, Australie (SYD)" },
      { value: "WLG", label: "Wellington, Nouvelle-Zélande (WLG)" },
    ],
  },
];


export const  formatPrixCFA = (montant) => {
  return new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: "XOF",
  }).format(montant);
}